export async function startPriceChooser(
    token,
    apiUrl = "http://localhost:8000/api/wppricing",
) {
    // check if we have a target element to render the price chooser in
    const target = document.querySelector("#cl_price_chooser");
    if (target == null) {
        console.log("error creating price chooser, no target element found");
        return;
    }
    const courseGroups = await getPricingData(token, apiUrl);
    let courseGroupsArray = [];
    if (!Array.isArray(courseGroups)) {
        // convert into an array of objects instead of an object of objects
        for (const [key, value] of Object.entries(courseGroups)) {
            courseGroupsArray.push(value);
        }
    } else {
        courseGroupsArray = courseGroups;
    }

    // add a header section with introduction text and remarks
    const headerElement = document.createElement("div");
    headerElement.classList.add("pricing-header");
    target.appendChild(headerElement);
    // unnumbered list for the remarks
    const remarksList = document.createElement("ul");
    const remark1 = document.createElement("li");
    remark1.innerText = "Prijzen voor duoles en groepsles zijn per deelnemer.";
    remarksList.appendChild(remark1);
    // general remarks above the calculator
    const headerText = document.createElement("p");
    headerText.innerText = "Wat zou je graag willen leren?";
    headerElement.appendChild(headerText); // order matters, this one first
    headerElement.appendChild(remarksList);

    // -----------------------------------
    // create an empty courseGroup select element
    // with a label in its own div element and append it to the target
    const courseGroupsElement = document.createElement("div");
    courseGroupsElement.classList.add("courseGroupChoice");
    target.appendChild(courseGroupsElement);
    const courseSelectLabel = document.createElement("label");
    courseSelectLabel.innerText = "";
    courseGroupsElement.appendChild(courseSelectLabel);
    const courseGroupElement = document.createElement("select");
    // create an option element for 0 value
    const courseGroupTitle0 = document.createElement("option");
    courseGroupTitle0.innerText = "Kies een instrument";
    courseGroupTitle0.value = 0;
    courseGroupElement.appendChild(courseGroupTitle0);
    courseGroupsArray.forEach((courseGroup) => {
        courseGroupElement.classList.add("courseGroup");
        const courseGroupTitle = document.createElement("option");
        courseGroupTitle.innerText = courseGroup.name;
        courseGroupTitle.value = courseGroup.id;
        courseGroupElement.appendChild(courseGroupTitle);
    });
    courseGroupsElement.appendChild(courseGroupElement);

    // -----------------------------------
    // ask the user to for age
    const ageElement = document.createElement("div");
    ageElement.classList.add("age");
    target.appendChild(ageElement);
    const ageLabel = document.createElement("label");
    ageLabel.innerText = "Wat is je leeftijd?";
    ageElement.appendChild(ageLabel);
    const ageInput = document.createElement("input");
    ageInput.classList.add("age");
    ageInput.type = "number";
    ageInput.min = 0;
    ageInput.max = 99;
    ageInput.value = 0;
    ageElement.appendChild(ageInput);

    // -----------------------------------
    // create an empty course select element with a label in its own div element and append it to the target
    const courseElement = document.createElement("div");
    courseElement.classList.add("courseChoice");
    target.appendChild(courseElement);
    const courseSelectLabel2 = document.createElement("label");
    courseSelectLabel2.innerText = "Kies een cursus";
    courseElement.appendChild(courseSelectLabel2);
    const courseSelectElement = document.createElement("select");
    courseSelectElement.classList.add("course");
    courseElement.appendChild(courseSelectElement);

    // -----------------------------------
    // create a target element for the price calculation with label "prijs" and append it to the target
    const priceElement = document.createElement("div");
    priceElement.classList.add("price");
    target.appendChild(priceElement);
    const priceLabel = document.createElement("div");
    priceLabel.classList.add("price-label");
    priceLabel.innerText = "Prijs:";
    priceElement.appendChild(priceLabel);
    const priceValue = document.createElement("div");
    priceValue.classList.add("price-value");
    priceValue.innerText = "€ 0";
    priceElement.appendChild(priceValue);

    // add eventhandler to the courseGroupElement
    courseGroupElement.addEventListener("change", (event) => {
        clearElements(ageInput, courseSelectElement, priceValue);
    });

    // add eventHandler to the ageInput
    ageInput.addEventListener("change", (event) => {
        if ((courseGroupElement.value === 0) || (Number.isInteger(parseInt(courseGroupElement.value)) === false)) {
            return;
        }
        getCoursesForAge(event.target.value, courseGroupsArray, courseSelectElement, courseGroupElement.value, priceValue);
    });

    // add eventHandler to the ageGroupSelectElement
    courseSelectElement.addEventListener("change", (event) => {
        calculateCoursePrice(courseGroupsArray, courseGroupElement.value, event.target.value, ageInput.value, priceElement, priceValue);
    });
}

async function getPricingData(token, apiUrl) {
    console.log("getting pricing data");
    const data = await fetch(apiUrl, {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        credentials: "include",
    });
    return await data.json();
}

/**
 * reset the ageInput, courseSelectElement and priceValue initially and after course group change
 * @param ageInput
 * @param courseSelectElement
 * @param priceValue
 */
const clearElements = (ageInput, courseSelectElement, priceValue) => {
    courseSelectElement.innerHTML = "";
    ageInput.value = 0;
    priceValue.innerText = "€ 0";
};

const getCoursesForAge = (age, allCourseGroups, courseSelectElement, courseGroupValue, priceValue) => {
    // empty current options of the courseSelectElement
    courseSelectElement.innerHTML = "";
    // empty priceelement
    priceValue.innerText = "€ 0";
    if (age === 0) {
        return;
    }
    // get the courses for the age
    const coursesForAge = [];
    const chosenCourseGroup = allCourseGroups.find(courseGroup => courseGroup.id === parseInt(courseGroupValue));
    const coursesInCourseGroup = chosenCourseGroup.courses;
    for (const [key, value] of Object.entries(coursesInCourseGroup)) {
        if (value.target_age_min <= age && value.target_age_max >= age) {
            coursesForAge.push(value);
        }
    }

    // Helper to get group type
    const getGroupType = (course) => {
        if (course.group_size_min === 1 && course.group_size_max === 1) return "individueel";
        if (course.group_size_min === 2 && course.group_size_max === 2) return "duo";
        if (course.group_size_min >= 2 || course.group_size_max > 2) return "groepsles";
        return "";
    };
    // Helper to get course type
    const getCourseType = (course) => {
        if (course.recurrenceoption.ends_after_nr_of_occurrences == null) return "Abonnement";
        if (course.recurrenceoption.ends_after_nr_of_occurrences === 1) return "Losse les";
        return "Overig";
    };
    // Helper to get timespan (for sorting and grouping)
    const getTimespan = (course) => {
        return `${course.recurrenceoption.nr_of_times} ${translateTimeUnit(course.recurrenceoption.timeunit)}`;
    };
    // Helper to get interval
    const getInterval = (course) => {
        return translateTimeUnit(course.recurrenceoption.per_interval);
    };
    // Helper to get sorting value for timespan
    const getTimespanValue = (course) => {
        return parseInt(course.recurrenceoption.nr_of_times) || 0;
    };

    // Group courses by group size
    const groupTypeOrder = ["individueel", "duo", "groepsles"];
    const grouped = { individueel: [], duo: [], groepsles: [] };
    coursesForAge.forEach(course => {
        const groupType = getGroupType(course);
        if (grouped[groupType]) grouped[groupType].push(course);
    });

    // create an option element for 0 value
    const courseTitle0 = document.createElement("option");
    courseTitle0.innerText = "Kies een cursus";
    courseTitle0.value = 0;
    courseSelectElement.appendChild(courseTitle0);

    groupTypeOrder.forEach(groupType => {
        if (!grouped[groupType] || grouped[groupType].length === 0) return;
        const optgroup = document.createElement("optgroup");
        optgroup.label = groupType;
        // Sort by abo form (Abonnement < Losse les < Overig), then timespan, then name
        grouped[groupType].sort((a, b) => {
            const getAboOrder = (course) => {
                const type = getCourseType(course);
                if (type === "Abonnement") return 0;
                if (type === "Losse les") return 1;
                return 2;
            };
            const aboA = getAboOrder(a);
            const aboB = getAboOrder(b);
            if (aboA !== aboB) return aboA - aboB;
            const aTime = getTimespanValue(a);
            const bTime = getTimespanValue(b);
            if (aTime !== bTime) return aTime - bTime;
            return a.name.localeCompare(b.name);
        });
        grouped[groupType].forEach(course => {
            const courseType = getCourseType(course);
            const timespan = getTimespan(course);
            const interval = getInterval(course);
            let label = "";
            if (courseType === "Losse les") {
                label = `${courseType} ${timespan} – ${course.name}`;
            } else {
                label = `${courseType} ${timespan} per ${interval} – ${course.name}`;
            }
            const courseOption = document.createElement("option");
            courseOption.innerText = label;
            courseOption.value = course.id;
            optgroup.appendChild(courseOption);
        });
        if (optgroup.children.length > 0) {
            courseSelectElement.appendChild(optgroup);
        }
    });
};

// Custom course name formatter for dropdown
const getCustomCourseName = (course, groupType, courseType, timespan, interval) => {
    // Remove 'op basis van', do not show group size range for groepsles
    let prefix = groupType;
    let name = course.name;
    // For groepsles, do not show range
    // Compose: "{groupType} {courseType} {name} {timespan} per {interval}"
    return `${prefix} ${courseType} ${name} ${timespan} per ${interval}`;
};

const getAccesibleCourseName = (course) => {
    const groupSize = groupSizeOfCourseAsText(course.group_size_min, course.group_size_max);
    const courseLength = `${course.recurrenceoption.nr_of_times} ${translateTimeUnit(course.recurrenceoption.timeunit)}`;

    // doorlopende cursus
    if (course.recurrenceoption.ends_after_nr_of_occurrences == null) {
        return `Abonnement ${course.name} op basis van ${courseLength} per ${translateTimeUnit(course.recurrenceoption.per_interval)} (${groupSize})`;
    } else if (course.recurrenceoption.ends_after_nr_of_occurrences === 1) {
        return `Losse les ${course.name} ${courseLength} (${groupSize})`;
    } else {
        return `${course.name} - ${course.recurrenceoption.description} (${groupSize})`;
    }
}

/**
 * get price of a course fopr a given age
 */
const priceOfCourseForAge = (age, course) => {
    // Translate price-per to Dutch. This maybe: 'month', 'week', 'time', twoweeks'
    if (age < 21) {
        return `€ ${course.price_ex_tax_sub_adult} per ${translateTimeUnit(course.price_is_per)} (BTW vrij)`;
    } else {
        return `€ ${course.price_invoice} per ${translateTimeUnit(course.price_is_per)} (inc. BTW)`;
    }
}

const translateTimeUnit = (timeUnit) => {
    switch (timeUnit) {
        case 'hour':
            return 'uur';
        case 'minute':
            return 'minuut';
        case 'minutes':
            return 'minuten';
        case 'day':
            return 'dag';
        case 'days':
            return 'dagen';
        case 'month':
            return 'maand';
        case 'week':
            return 'week';
        case 'time':
            return 'keer';
        case 'twoweeks':
            return 'twee weken';
        case 'sequence':
            return 'reeks';
        default:
            return timeUnit;
    }
}
/** calculate the price for the chosen course
 * @param age
 * @param courseGroups
 * @param courseGroupId
 * @param courseId
 * @param age
 * @param priceElement
 * @param priceValueElement
 */
const calculateCoursePrice = (courseGroups, courseGroupId, courseId, age, priceElement, priceValueElement) => {

    const courseGroup = courseGroups.find(courseGroup => courseGroup.id === parseInt(courseGroupId));
    // find the correct course in the courseGroup.courses
    let course = {};
    for (const [key, value] of Object.entries(courseGroup.courses)) {
        if (value.id === parseInt(courseId)) {
            course = value;
            break;
        }
    }

    priceValueElement.innerText = priceOfCourseForAge(age, course);

    // set price element visible
    priceElement.classList.add("price--visible");
};

export async function startCoursePriceForAge(
    token,
    apiUrl = "http://localhost:8000/api/wppricing",
) {
    // check if we have a target element to render the calendar in
    const target = document.querySelector("#cl_course_price_for_age");
    if (target == null) {
        console.log("error creating course/price chooser, no target element found");
        return;
    }
    const courseGroups = await getPricingData(token, apiUrl);
    // arrange the data in an array of objects instead of an object of objects
    let courseGroupsArray = [];
    if (!Array.isArray(courseGroups)) {
        for (const [key, value] of Object.entries(courseGroups)) {
            courseGroupsArray.push(value);
        }
    } else {
      courseGroupsArray = courseGroups;
    }

    // add a header section with introduction text and remarks
    const headerElement = document.createElement("div");
    headerElement.classList.add("course-pricing-header");
    target.appendChild(headerElement);
    // unnumbered list for the remarks
    const remarksList = document.createElement("ul");
    const remark1 = document.createElement("li");
    remark1.innerText = "Prijzen voor duoles en groepsles zijn per deelnemer.";
    remarksList.appendChild(remark1);
    // general remarks above the calculator
    const headerText = document.createElement("p");
    headerText.innerText = "Vul je leeftijd in om alle cursussen voor jou te ontdekken!";
    headerElement.appendChild(headerText); // order matters, this one first
    headerElement.appendChild(remarksList);
    // create an element to contain the age input
    const ageElement = document.createElement("div");
    ageElement.classList.add("age-container");
    target.appendChild(ageElement);
    const ageLabel = document.createElement("label");
    ageLabel.innerText = "Wat is je leeftijd?";
    ageElement.appendChild(ageLabel);
    const ageInput = document.createElement("input");
    ageInput.classList.add("age");
    ageInput.type = "number";
    ageInput.min = 0;
    ageInput.max = 99;
    ageInput.value = 0;
    ageElement.appendChild(ageInput);

    // create an empty course select element with a label in its own div element and append it to the target
    const courseElement = document.createElement("div");
    courseElement.classList.add("courseChoice");
    target.appendChild(courseElement);
    const courseSelectLabel2 = document.createElement("label");
    courseSelectLabel2.innerText = " "; // distance to the age input
    courseElement.appendChild(courseSelectLabel2);
    const courseTableElement = document.createElement("table");
    courseTableElement.classList.add("courses-for-age");
    courseElement.appendChild(courseTableElement);

    // add eventHandler to the ageInput
    ageInput.addEventListener("change", (event) => {
        getAllCoursesForAge(event.target.value, courseGroupsArray, courseTableElement);
    });
}

const getCourseGroupName = (courseGroupId, courseGroupsArray) => {
    const courseGroup = courseGroupsArray.find(courseGroup => courseGroup.id === parseInt(courseGroupId));
    return courseGroup.name;
}
const getAllCoursesForAge = (age, allCourseGroups, courseTableElement) => {
    // empty current listitems of the courseListElement
    courseTableElement.innerHTML = "";
    // if we have a #courseTitle0 element, remove it
    const courseTitle0 = document.querySelector("#coursesTitle0");
    if (courseTitle0) {
        courseTitle0.remove();
    }

    if (age === 0) {
        return;
    }
    // get the courses for the age
    const courseGroupCoursesForAge = [];
    let totalNrOfCoursesFound = 0;
    allCourseGroups.forEach(courseGroup => {
        const coursesForAge = [];
        const coursesInCourseGroup = courseGroup.courses;
        for (const [key, value] of Object.entries(coursesInCourseGroup)) {
            if (value.target_age_min <= age && value.target_age_max >= age) {
                totalNrOfCoursesFound++;
                coursesForAge.push(value);
            }
        }
        courseGroupCoursesForAge.push({coursegroup: {id: courseGroup.id, name: courseGroup.name}, courses: coursesForAge});
    });
    // order the courseGroupCoursesForAge by coursegroup name
    courseGroupCoursesForAge.sort((a, b) => {
        if (a.coursegroup.name < b.coursegroup.name) {
            return -1;
        }
        return 1;
    });

    if (totalNrOfCoursesFound === 0) {
        const courseOption = document.createElement("tr");
        courseOption.innerHTML = `<td>Er zijn geen cursussen beschikbaar voor jouw leeftijd</td>`;
        courseTableElement.appendChild(courseOption);
        return;
    }

    // create an option element for 0 value
    const coursesTitle0 = document.createElement("p");
    // add id to be able to find it later on
    coursesTitle0.id = "coursesTitle0";
    coursesTitle0.innerText = "Deze cursussen zijn er voor jou:";
    // insert title before the table
    courseTableElement.insertAdjacentElement('beforebegin', coursesTitle0);

    // preserve scroll position
    const scrollPosition = {y: window.scrollY, x: window.scrollX};

    // create a table row for each course, group by coursegroup
    let firstRow = true;
    courseGroupCoursesForAge.forEach(courseGroup => {
        if (courseGroup.courses.length === 0) {
            return;
        }
        if (!firstRow) {
            const courseGroupSeparator = document.createElement("tr");
            courseGroupSeparator.classList.add("course-group-separator");
            courseGroupSeparator.innerHTML = `<td colspan="2" style="background-color: white;">&nbsp;</td>`;
            courseTableElement.appendChild(courseGroupSeparator);
        }
        firstRow = false;
        // add a table header for the course group
        const courseGroupTitle = document.createElement("tr");
        courseGroupTitle.classList.add("course-group-title");
        courseGroupTitle.innerHTML = `<th colspan="2">${courseGroup.coursegroup.name}</th>`;
        courseTableElement.appendChild(courseGroupTitle);
        // order the courses within this course group by name
        courseGroup.courses.sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            return 1;
        });

        // add a table row for each course
        courseGroup.courses.forEach(course => {
            const courseOption = document.createElement("tr");
            const price = priceOfCourseForAge(age, course);
            const accesibleCourseName = getAccesibleCourseName(course);
            courseOption.innerHTML = `<td>${accesibleCourseName}</td><td><strong>${price}</strong></td>`;
            courseTableElement.appendChild(courseOption);
        });
    });
    // restore scroll position
    setTimeout(() => {
        window.scrollTo(scrollPosition.x, scrollPosition.y);
    }, 200);
}

/**
 * Get a string with the classification of the group size for a course:
 * min === max === 1: "individueel"
 * min === max === 2: "duo"
 * min && max > 2: "groep van min - max"
 * @param min
 * @param max
 * @returns {*|string}
 */
const groupSizeOfCourseAsText = (min, max) => {
    if (min === 1 && max === 1) {
        return "individueel";
    }
    if (min === 2 && max === 2) {
        return "duo";
    }
    return `groep van ${min} - ${max}`;
}

